'use client';
import React, { useState, Suspense } from 'react';
import { useLang } from '@/lib/langContext';

import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import LanguageToggle from '@/components/LanguageToggle';
import AppLogo from '@/components/ui/AppLogo';

export default function AuthPageClient() {
  const { lang } = useLang();
  const [mode, setMode] = useState<'signin' | 'signup'>('signin');

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Brand Panel */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-[55%] bg-navy-600 flex-col justify-between p-12 relative overflow-hidden">
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-20 w-64 h-64 rounded-full border border-white" />
          <div className="absolute top-40 left-40 w-96 h-96 rounded-full border border-white" />
          <div className="absolute bottom-20 right-20 w-48 h-48 rounded-full border border-white" />
        </div>

        {/* Logo */}
        <div className="flex items-center gap-3 relative z-10">
          <AppLogo size={40} />
          <span className="text-white font-bold text-2xl tracking-tight">Votly</span>
        </div>

        {/* Hero copy */}
        <div className="relative z-10 space-y-6">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20">
            <span className="w-2 h-2 rounded-full bg-gold-400 animate-pulse" />
            <span className="text-white/80 text-sm font-medium">Buyer Experience Platform · MENA</span>
          </div>
          <h1 className="text-4xl xl:text-5xl font-bold text-white leading-tight">
            Know exactly where buyer experience is breaking down.
          </h1>
          <p className="text-white/70 text-lg leading-relaxed max-w-md">
            Capture handover and snagging feedback from buyers — in Arabic or English — and get dashboards that tell you what to fix first.
          </p>
        </div>

        {/* Bottom stat removed */}
      </div>
      {/* Form Panel */}
      <div className="flex-1 flex flex-col">
        <div className="flex items-center justify-between p-4 lg:p-6">
          <div className="flex items-center gap-2 lg:hidden">
            <AppLogo size={28} />
            <span className="font-bold text-navy-600">Votly</span>
          </div>
          <div className="lg:ms-auto">
            <LanguageToggle />
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center px-6 py-8">
          <div className="w-full max-w-md">
            <Suspense fallback={<div className="h-64" />}>
              {mode === 'signin' ? (
                <SignInForm onSwitchToSignUp={() => setMode('signup')} />
              ) : (
                <SignUpForm onSwitchToSignIn={() => setMode('signin')} />
              )}
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
}